import React, {useEffect} from "react";
import {css} from "@emotion/react";

import {CreationListingPosition} from "../offer/list/components/OfferList/listing_variants/DefaultOfferListing";
import {HeroCreation} from "./creations/HeroCreation";
import {ImageAdCreation} from "./creations/ImageAdCreation";
import {MonthlyCreation} from "./creations/MonthlyCreation";
import {NativeCreation} from "./creations/NativeCreation";
import {SurpriseCreation} from "./creations/surprise_creation/SurpriseCreation";
import {TdaCreation} from "./creations/TdaCreation";
import {CreationType} from "./types/CreationType";
import {IAdMeta} from "./types/IAdMeta";
import {ICreation} from "./types/ICreation";
import {IHeroCreation} from "./types/IHeroCreation";
import {ISurpriseCreation} from "./types/ISurpriseCreation";
import {ITdaCreation} from "./types/ITdaCreation";

interface IProps {
    creation: ICreation | ISurpriseCreation | IHeroCreation | ITdaCreation;
    adMeta: IAdMeta;
    url: string;
    metadata: {sas_id: string};
    onAfterFirstRender?: () => void;
    referenceElementId?: string;
    preventGtmOnMobile?: boolean;
}

export const Creation = (props: IProps) => {
    const {onAfterFirstRender, referenceElementId} = props;

    useEffect(() => {
        if (onAfterFirstRender) {
            onAfterFirstRender();
        }
    }, []);

    switch (props.creation.type) {
        case CreationType.NATIVE:
            return <NativeCreation creation={props.creation} url={props.url} />;
        case CreationType.MONTHLY:
            return <MonthlyCreation creation={props.creation} url={props.url} />;
        case CreationType.IMAGE:
            return <ImageAdCreation creation={props.creation} url={props.url} />;
        case CreationType.SURPRISE:
            return (
                <SurpriseCreation
                    creation={props.creation as ISurpriseCreation}
                    url={props.url}
                    metadata={{...props.metadata, position: CreationListingPosition.SURPRISE_LONG}}
                    referenceElementId={referenceElementId}
                />
            );
        case CreationType.HERO:
            return <HeroCreation creation={props.creation as IHeroCreation} url={props.url} preventGtmOnMobile={props.preventGtmOnMobile} />;
        case CreationType.TDA:
            return <TdaCreation creation={props.creation as ITdaCreation} url={props.url} preventGtmOnMobile={props.preventGtmOnMobile} />;
        default:
            return null;
    }
};

export const centerAdCreation = css`
    margin: 0 auto;
`;
